import { useEffect, useState } from "react";

// True on phones / touch devices — used to drop heavy 3D & WebGL for instant browsing.
export function useLightMode() {
  const [light, setLight] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia("(max-width: 767px), (pointer: coarse)");
    const update = () => setLight(mq.matches);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, []);
  return light;
}
